import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import PanelBarItemViewModelType from '@/ViewModels/Controls/PanelBarItemViewModel';
import LabelType from '@/Controls/Label';
import TreeViewType from '@/Controls/TreeView';

export default class PanelBarItem extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private TreeView = ComponentManager.getControl<typeof TreeViewType>('TreeView');
    private jQueryControl: JQuery;
    private label: LabelType;
    private treeView: TreeViewType;

    public constructor(private viewModel: PanelBarItemViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<li>');

        this.applyBindings(this.jQueryControl, {
            kendoPanelItem: {
                expanded: this.viewModel.isExpanded,
                selected: this.viewModel.isSelected,
                widget: this.widget
            }
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: any): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'panelbaritem',
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];
                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }
                    if (this.viewModel.isExpanded() === true) {
                        states.push('expanded');
                    } else {
                        states.push('collapsed');
                    }
                    if (this.viewModel.isSelected() === true) {
                        states.push('selected');
                    } else {
                        states.push('unselected');
                    }
                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }
                    if (this.viewModel.hasFullHeight() === true) {
                        states.push('fullheight');
                    } else {
                        states.push('defaultheight');
                    }
                    return states;
                }
            })
        });

        $('.c-panelbaritem').children('.k-link').remove();

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.treeView != null) {
            this.treeView = new this.TreeView(this.viewModel.treeView);
            let tuple = this.treeView.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('PanelBarItem', PanelBarItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');